import { tss } from "tss-react/mui";

export const useRelatedProductsSectionStyles = tss.withName("RelatedProductsSection").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.primary[50],
    },
    title: {
        marginBottom: theme.spacing(4),
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: theme.spacing(4),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        [theme.breakpoints.down("sm")]: {
            gap: theme.spacing(2.5),
        },
    },
}));
